import { UseFormRegister } from "react-hook-form";
import InputField from "../../components/UI/Inputs/InputField";
import { useTranslation } from "../../hooks/useTranslation";
import style from "./index.module.css";

const PersonalInfo = ({ register, isEditing }: ComponentPropsType) => {
  const { locale } = useTranslation();

  return (
    <>
      <div className={style.page_section}>
        <InputField type="text" extraProps={{ ...register("name"), disabled: true }} label={locale("name")} />
      </div>
      <div className={style.page_section}>
        <InputField type="phone" extraProps={{ ...register("phone"), disabled: true }} label={locale("phone")} />
      </div>
      {/* <div className={style.page_section}>
        <InputField
          type="text"
          extraProps={{ ...register("email"), disabled: true }}
          label={translation[siteLang].email}
        />
      </div> */}
      {/* <div className={style.page_section}>
        <InputField
          type="text"
          extraProps={register("national_id")}
          label={translation[siteLang].national_id}
        />
      </div> */}
      {/* <div className={style.page_section}>
        <InputField
          type="text"
          extraProps={register("license_id")}
          label={translation[siteLang].license_id}
        />
      </div> */}
      {!isEditing && (
        <div className={style.page_section}>
          <InputField type="checkbox" extraProps={register("acknowledgement")} label={locale("acknowledgement")} />
        </div>
      )}
    </>
  );
};

export default PersonalInfo;

type ComponentPropsType = {
  register: UseFormRegister<any>;
  isEditing: boolean;
};
